/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';

const SIZE_PRESETS = {
  xs: 'text-[10px] h-4 w-4',
  sm: 'text-[12px] h-[18px] w-[18px]',
  md: 'text-[14px] h-5 w-5',
  lg: 'text-base h-6 w-6',
};

const SeloApoiadorInline = ({ selo, size = 'sm', className = '' }) => {
  if (!selo?.ativo || !selo?.plano) {
    return null;
  }

  const { plano } = selo;
  const corBase = plano.seloCor || 'currentColor';
  const sizeClass = SIZE_PRESETS[size] || SIZE_PRESETS.sm;
  const titleText = plano.seloLabel || plano.nome || '';

  return (
    <span
      aria-label={titleText}
      title={titleText}
      className={`inline-flex shrink-0 items-center justify-center rounded-full leading-none align-middle select-none ${sizeClass} ${className}`}
      style={{
        color: corBase,
        backgroundColor: plano.seloCor ? `${plano.seloCor}1F` : undefined,
        border: `1px solid ${plano.seloCor ? `${plano.seloCor}66` : 'currentColor'}`,
      }}
    >
      <span aria-hidden="true">{plano.seloEmoji || '★'}</span>
    </span>
  );
};

SeloApoiadorInline.propTypes = {
  selo: PropTypes.shape({
    ativo: PropTypes.bool,
    plano: PropTypes.shape({
      seloCor: PropTypes.string,
      seloEmoji: PropTypes.string,
      seloLabel: PropTypes.string,
      nome: PropTypes.string,
    }),
  }),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default SeloApoiadorInline;
